import React, {Component, Fragment} from 'react'
import {Form, Col, Row} from "react-bootstrap";
import SelectSearch from "../../../ui/select/SelectSearch";
import SelectFilter from "../../../ui/select/SelectFilter";
import PlayerCard from "./PlayerCard";
import '../../../../assets/sass/pages/compare-players.scss';
import Tools from "../../../../Tools";
import NoError from "../../../ui/feedback/NoError";
import {gql, useQuery} from "@apollo/client";
import Loading from "../../../ui/feedback/Loading";

const queryString = require('query-string');

class ComparePlayers extends Component {

    constructor(props) {
        super(props);
        Tools.redirectToErrorPage(props, ['talent-search', 'watchlist']);
    }

    state = {
        competitions: [
            {key: 0, value: 'all', label: 'All Competition'},
            {key: 1, value: 'competition-1', label: 'Competition 1'},
            {key: 2, value: 'competition-1', label: 'Competition 2'},
            {key: 3, value: 'competition-1', label: 'Competition 3'}
        ],
        seasons: [
            {key: 0, value: 'all', label: 'All Seasons'},
            {key: 1, value: 'Season-1', label: 'Season 1'},
            {key: 2, value: 'Season-1', label: 'Season 2'},
            {key: 3, value: 'Season-1', label: 'Season 3'}
        ],
    };

    render = () => {
        return (
            <div className="compare-player-wrapper">
                <Form>
                    <Form.Row className="row form">
                        <Col className="col-xl-2 col pr-0 mr-3 col">
                            <SelectSearch
                                type="lg"
                                name="countries"
                                placeholder="All Competitions"
                                searchPlaceholder="Search ..."
                                options={this.state.competitions}
                            />
                        </Col>
                        <Col className="col-xl-2 col mr-0 col">
                            <SelectFilter
                                type="lg"
                                name="seasons"
                                placeholder="All Seasons"
                                options={this.state.seasons}
                            />
                        </Col>
                    </Form.Row>
                </Form>

                {this.renderPlayerCards()}
            </div>
        );
    };


    renderPlayerCards = () => {
        const {firstPlayer, secondPlayer, thirdPlayer} = this.props;

        return (
            <Fragment>
                <div className="players player-3">
                    {firstPlayer && <PlayerCard player={firstPlayer}/>}
                    {secondPlayer && <PlayerCard player={secondPlayer}/>}
                    {thirdPlayer && <PlayerCard player={thirdPlayer}/>}
                </div>
            </Fragment>
        )
    };
}

ComparePlayers.Error = NoError.WithWrapper;
ComparePlayers.Error404 = NoError.E404WithWrapper;
ComparePlayers.Loading = Loading.WithWrapper;

const ComparePlayersDataWrapper = props => {
    const {query: {first, second, third}} = queryString.parseUrl(window.location.href);

    const query = gql`
        query comparePlayers ($first: String!, $second: String!, $third: String! = "", $compareThird: Boolean!) {
            firstPlayer: player(id: $first){
                ...comparisonFields
            }

            secondPlayer: player(id: $second) {
                ...comparisonFields
            }

            thirdPlayer: player(id: $third) @include(if: $compareThird){
                ...comparisonFields
            }
        }

        fragment comparisonFields on PlayerModel{
            id
            avatar
            name
            position
            team{
                name
            }
            nationality{
                name
            }
            overallScore
            dob
            weight
            height
            foot
            careerStats{
                matchesPlayed
                goalsScored
                assists
                passingAccuracy
                tackleSuccessRate
            }
        }
    `;


    const formatPlayer = player => {
        if (!player)
            return null;

        return {
            id: player.id,
            avatar: player.avatar,
            name: player.name,
            position: player.position,
            teamName: player.team.name,
            birthCountry: player.nationality?.name,
            passportCountry: player.passport?.name,
            overallScore: player.overallScore,
            age: Tools.calculateAge(new Date(player.dob)),
            weight: player.weight,
            height: player.height,
            foot: Tools.capitalize(player.foot),

            matchesPlayed: player.careerStats[0].matchesPlayed,
            goalsScored: player.careerStats[0].goalsScored,
            assists: player.careerStats[0].assists,
        }
    };


    const variables = {
        first: first,
        second: second,
        third: third,
        compareThird: !!third
    };

    const {loading, error, data} = useQuery(query, {
        variables: variables,
    });

    if (!first || !second) {
        return (
            <ComparePlayers.Error404/>
        );
    }
    if (loading) {
        return (
            <ComparePlayers.Loading/>
        );
    }
    if (error) {
        return (
            <ComparePlayers.Error/>
        )
    }

    const {firstPlayer, secondPlayer, thirdPlayer} = data;

    return (
        <ComparePlayers
            firstPlayer={formatPlayer(firstPlayer)}
            secondPlayer={formatPlayer(secondPlayer)}
            thirdPlayer={formatPlayer(thirdPlayer)}
            {...props}
        />
    );

};

export default ComparePlayersDataWrapper;
